import { Col, H1, HeroAmount, ShortSplitter, Span } from '@landsbankinn/ui-kit';
import { useConsentClientContext } from 'src/components/Consent/State/consentClientState.tsx';

export function OverlayHeader(props: {
  title?: string;
  subHero?: string;
  background?: 'backgroundAlt';
}) {
  const [consentClient] = useConsentClientContext();
  const hero = consentClient.hero;

  return (
    <Col
      background={
        props.background === 'backgroundAlt' ? 'blue baseLight' : undefined
      }
    >
      {hero && (
        <>
          <H1 fontVariant="h4">{props.title}</H1>
          <ShortSplitter height="32" />
          <HeroAmount
            fontSize="60"
            currency={hero.label ?? 'ISK'}
            type="currency"
            value={hero.value}
          />
          <Span fontVariant="table">{hero.localized_name}</Span>
        </>
      )}
      {!hero && (
        <>
          {props.title && <H1 fontVariant="h4">{props.title}</H1>}
          {props.title && <ShortSplitter height="32" />}
          {props.subHero && <Span fontVariant="body">{props.subHero}</Span>}
        </>
      )}
    </Col>
  );
}
